import React from "react";
import { SiVisualstudiocode, SiGoogle, SiNotion, SiObsidian, SiOpenai } from "react-icons/si";
import { PiCursorFill } from "react-icons/pi";
import { FaRegLightbulb } from "react-icons/fa";
import { TbSquareRoundedCheck } from "react-icons/tb";
import { MdOutlineAccessTime } from "react-icons/md";

const toolCategories = [
  {
    title: "Learning",
    blurb: "To make learning engaging and efficient",
    tools: [
      {
        name: "NotebookLM",
        icon: <SiGoogle />,
        color: "#ea4335",
        // usage: "Ground long-form research notes and ask follow-up questions on my readings."
      },
      {
        name: "Learn About (Google)",
        icon: <FaRegLightbulb />,
        color: "#fbbc05",
        // usage: "Experiment playground to teach complex topics with interactive stories."
      }
    ]
  },
  {
    title: "Coding",
    blurb: "IDE and coding agent, to match execution speed with ideas. ",
    tools: [
      {
        name: "VS Code",
        icon: <SiVisualstudiocode />,
        color: "#007acc",
        // usage: "Primary editor + remote dev environment."
      },
      {
        name: "Cursor",
        icon: <PiCursorFill />,
        color: "#3b82f6",
        // usage: "Pair-programming with AI for rapid prototyping."
      },
      {
        name: "Codex",
        icon: <SiOpenai />,
        color: "#10a37f",
        // usage: "Use Codex-style completions for scaffolding APIs + tests."
      }
    ]
  },
  {
    title: "Notes",
    blurb: "For the miracle-minded monkey-brain",
    tools: [
      {
        name: "Notion",
        icon: <SiNotion />,
        color: "#000000",
        // usage: "Project wikis + client-ready artifacts."
      },
      {
        name: "Obsidian",
        icon: <SiObsidian />,
        color: "#8c7bff",
        // usage: "Second brain of atomic research notes + graph views."
      }
    ]
  },
  {
    title: "Task & Time Management",
    // blurb: "Tools that keep my calendar sane and execution intentional.",
    tools: [
      {
        name: "Things",
        icon: <TbSquareRoundedCheck />,
        color: "#2563eb",
        // usage: "Daily capture, rituals, and personal OKRs."
      },
      {
        name: "Reclaim",
        icon: <MdOutlineAccessTime />,
        color: "#ff6f61",
        usage: "Auto time-blocking for deep work, tasks and meetings"
      }
    ]
  }
];

function Toolstack() {
  return (
    <div className="toolstack-grid">
      {toolCategories.map((category) => (
        <div className="tool-category" key={category.title}>
          <div className="tool-category-header">
            <h3>{category.title}</h3>
            <p>{category.blurb}</p>
          </div>
          <div className="tool-pill-grid">
            {category.tools.map((tool) => (
              <div
                key={tool.name}
                className="tool-pill"
                style={{ borderColor: tool.color }}
                data-hover={tool.usage ?? tool.name}
                title={tool.usage ?? tool.name}
              >
                <span className="tool-pill-icon" style={{ color: tool.color }}>
                  {tool.icon}
                </span>
                <span className="tool-pill-label">{tool.name}</span>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

export default Toolstack;
